"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasBeenAnswered = hasBeenAnswered;
exports.flattenAnswers = flattenAnswers;
exports.areAnswersForRepeatedFieldGroups = areAnswersForRepeatedFieldGroups;
const lodash_1 = __importDefault(require("lodash"));
function hasBeenAnswered(answer) {
    return !lodash_1.default.isEmpty(answer) || lodash_1.default.isNumber(answer) || answer === true;
}
// Similar to https://github.com/hughsk/flat, but will not flatten arrays when they're leaves in the answers structure
function flattenAnswers(answers, delimiter, currentPath, flatAnswers = {}) {
    if (areAnswersForRepeatedFieldGroups(answers)) {
        answers.forEach((obj, index) => {
            const newPath = currentPath ? `${currentPath}${delimiter}${index}` : `${index}`;
            flattenAnswers(obj, delimiter, newPath, flatAnswers);
        });
        return flatAnswers;
    }
    if (Array.isArray(answers)) {
        // leaf is an array, so we do not flatten it
        // answers are related to a multi-choice type, e.g. checkboxGroup
        lodash_1.default.set(flatAnswers, [currentPath ?? ''], answers);
        return flatAnswers;
    }
    Object.entries(answers).forEach(([key, value]) => {
        const newPath = currentPath ? `${currentPath}${delimiter}${key}` : key;
        if (typeof value === 'object' && value !== null) {
            flattenAnswers(value, delimiter, newPath, flatAnswers);
        }
        else {
            lodash_1.default.set(flatAnswers, [newPath], value);
        }
    });
    return flatAnswers;
}
function areAnswersForRepeatedFieldGroups(answers) {
    return Array.isArray(answers) && answers.every((answer) => answer && typeof answer === 'object');
}
